import { IconButton, Stack, Switch } from "@mui/material";
import { CustomTextView } from "../../component/CustomTextView";
import {
  CheckBox,
  CheckRounded,
  CloseRounded,
  DownloadRounded,
} from "@mui/icons-material";
import {
  COLOR_BLACK,
  COLOR_LIGHT_GRAY,
  COLOR_MAIN,
} from "../../../data/colors/Colors";
import { CustomTextField } from "../../component/CustomTextField";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { useEffect, useState } from "react";
import { FilterTrucksByModel } from "../../../domain/model/Truck";

export function FilterTruckView({
  onClose,
  onGenerateXMLFileClicked,
  onFilterClicked,
  filteringModel,
  setFilteringModel,
}: {
  onClose: () => void;
  onGenerateXMLFileClicked: () => void;
  onFilterClicked: () => void;
  filteringModel: FilterTrucksByModel | undefined;
  setFilteringModel: (filteringModel: FilterTrucksByModel) => void;
}) {
  const [startDate, setStartDate] = useState<Date | null>(
    filteringModel?.rangeDate?.startDate
      ? new Date(filteringModel.rangeDate.startDate)
      : new Date(new Date().getTime() - 20 * 60 * 1000)
  );
  const [endDate, setEndDate] = useState<Date | null>(
    filteringModel?.rangeDate?.endDate
      ? new Date(filteringModel.rangeDate.endDate)
      : new Date()
  );

  const [allTime, setAllTime] = useState(
    filteringModel?.rangeDate == undefined
  );

  useEffect(() => {
    if (startDate != undefined && endDate != undefined && endDate > startDate) {
      setFilteringModel({
        ...filteringModel,
        rangeDate: allTime
          ? undefined
          : {
              startDate: startDate.toISOString(),
              endDate: endDate.toISOString(),
            },
      });
    }
  }, [startDate, endDate, allTime]);

  return (
    <Stack minWidth={"30vmax"} minHeight={"20vh"} p={2} spacing={6}>
      <Stack
        width={"100%"}
        justifyContent={"space-between"}
        alignItems={"center"}
        direction={"row"}
      >
        <CustomTextView text={"Filter"} fontWeight="bold" variant="h5" />

        <Stack alignItems={"center"} direction={"row"} spacing={1}>
          <IconButton
            sx={{ border: "solid 1px " + COLOR_MAIN }}
            onClick={() => {
              onGenerateXMLFileClicked();
            }}
          >
            <DownloadRounded
              sx={{
                color: COLOR_MAIN,
              }}
            />
          </IconButton>
          <IconButton
            sx={{ border: "solid 1px " + COLOR_MAIN }}
            onClick={onFilterClicked}
          >
            <CheckRounded sx={{ color: COLOR_MAIN }} />
          </IconButton>
          <IconButton
            sx={{ border: "solid 1px " + COLOR_BLACK }}
            onClick={onClose}
          >
            <CloseRounded sx={{ color: COLOR_BLACK }} />
          </IconButton>
        </Stack>
      </Stack>

      <Stack spacing={2}>
        <Stack spacing={1}>
          <CustomTextView
            text={"Truck Route"}
            fontWeight="bold"
            variant="body1"
          />
          <CustomTextField
            placeholder="Truck Route"
            value={filteringModel?.name}
            onTextChange={(name) => {
              setFilteringModel({ ...filteringModel, name });
            }}
            borderColor={"lightGray"}
          />
        </Stack>

        <Stack spacing={1}>
          <Stack spacing={1} direction={"row"} alignItems={"center"}>
            <CustomTextView
              text={"All Time"}
              fontWeight="bold"
              variant="body1"
            />
            <Switch
              color="success"
              checked={filteringModel?.rangeDate == undefined && allTime}
              onChange={(_, checked) => {
                setAllTime(checked);
              }}
            />
          </Stack>
          <Stack
            spacing={1}
            direction={"row"}
            alignItems={"center"}
            width={"100%"}
            sx={allTime ? { filter: "blur(6px)", pointerEvents: "none" } : {}}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateTimePicker
                label="Start Date"
                slotProps={{
                  textField: {
                    InputProps: { sx: { borderRadius: 22 } },
                  },
                }}
                value={dayjs(startDate?.toISOString())}
                onChange={(d) => {
                  try {
                    const date = d?.toDate();
                    if (date) {
                      setStartDate(date);
                    }
                  } catch (e) {
                    setStartDate(new Date());
                  }
                }}
              />
              <DateTimePicker
                label="End Date"
                slotProps={{
                  textField: {
                    InputProps: { sx: { borderRadius: 22 } },
                  },
                }}
                value={dayjs(endDate?.toISOString())}
                onChange={(d) => {
                  try {
                    const date = d?.toDate();
                    if (date) {
                      setEndDate(date);
                    }
                  } catch (e) {
                    setEndDate(new Date());
                  }
                }}
              />
            </LocalizationProvider>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}
